<template>
  <v-container fluid ma-0 pa-0>
    <v-layout row>
      <v-flex :class="showEnvelopeDetailsDialog ? 'xs7' : 'xs12'">
        <v-layout row class="mediumMargin layouttitletop">
          <v-flex xs10>
            <div class="pagecontainer">
              <span class="header-title">{{ labels.header }}</span>
            </div>
            <div class="pagecontainer">
              <v-flex xs12 class="py-2">
                <ul class="tabs">
                  <li><a href="#/ice" :class="currentFilter === 'all' ? 'activetab' : ''" @click="currentFilter = 'all'; loadAllEnvelopes()">{{$t('ICE.ListICE.ALL_ICE_MENU_LINK')}}</a></li>
                  <li><a href="#/ice" :class="currentFilter === 'assessing' ? 'activetab' : ''" @click="currentFilter = 'assessing'; loadAllEnvelopes()">{{$t('ICE.ListICE.ASSESSING_MENU_LINK')}}</a></li>
                  <li><a href="#/ice" :class="currentFilter === 'active' ? 'activetab' : ''" @click="currentFilter = 'active'; loadAllEnvelopes()">{{$t('ICE.ListICE.ACTIVE_MENU_LINK')}}</a></li>
                  <li><a href="#/ice" :class="currentFilter === 'archived' ? 'activetab' : ''" @click="currentFilter = 'archived'; loadAllEnvelopes()">{{$t('ICE.ListICE.ARCHIVED_MENU_LINK')}}</a></li>
                </ul>
              </v-flex>
            </div>
          </v-flex>
          <v-flex xs2>
            <v-btn v-if="canRequestEnvelope && !showEnvelopeDetailsDialog" color="primary" @click="requestNewEnvelope">{{ labels.newResourceButtonLabel }} <span class="icon-plus"></span></v-btn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <EmptyStatePlaceHolder v-if="!isLoading && envelopeList.length === 0" header="" :description="labels.emptyStateDescription" :canCreateResource="false" />
            <EnvelopeList v-if="isLoading || envelopeList.length > 0" :envelopes="tableItems" :tableHeaders="tableHeaders" :isActionEnabled="isActionEnabled" :isLoading="isLoading" :selectedItemId="currentEnvelope ? currentEnvelope.id : undefined" :paginationData="paginationData" @itemClicked="showDetails" @cancelEnvelope="cancelEnvelope" @loadAllEnvelopes="loadAllEnvelopes" />
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
    <EnvelopeDetails v-model="showEnvelopeDetailsDialog" :envelope="currentEnvelope" @envelopeRequested="envelopeRequested"/>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import EmptyStatePlaceHolder from '@/components/EmptyStatePlaceholder.vue'
import EnvelopeList from '@/components/ICE/EnvelopeList.vue'
import EnvelopeDetails from '@/components/ICE/EnvelopeDetails.vue'
import transactorApi from '@/services/TransactorApi'
import envelopeApi from '@/services/EnvelopeApi'
export default {
  name: 'envelopeDashboard',
  components: {
    EmptyStatePlaceHolder,
    EnvelopeDetails,
    EnvelopeList
  },
  data () {
    return {
      labels: {
        header: this.$t('ICE.ListICE.LIST_ICE_TITLE'),
        emptyStateDescription: this.$t('ICE.ListICE.NOT_REQUEST_ICE_DESC'),
        newResourceButtonLabel: this.$t('ICE.ListICE.REQUEST_ICE_BTN'),
        cancelEnvelopeSuccess: this.$t('ICE.ListICE.SUCCESSFULLY_CANCELLED_DESC'),
        cancelEnvelopeFailed: this.$t('ICE.ListICE.FAILED_TO_CANCEL_DESC')
      },
      canRequestEnvelope: true,
      showEnvelopeDetailsDialog: false,
      currentEnvelope: undefined,
      envelopeList: [],
      isLoading: false,
      paginationData: {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: 'createdAt',
        totalItems: 0,
        rowsPerPageItems: [5]
      },
      currentFilter: 'all',
      defaultTableHeaders: [
        { text: '', align: 'left', value: 'first', sortable: false },
        { text: this.$t('ICE.ListICE.BUYER_COLUMN_NAME'), align: 'left', value: 'buyer', sortable: false },
        { text: this.$t('ICE.ListICE.REQUESTED_COLUMN_NAME'), align: 'left', value: 'requestedAmount', sortable: false },
        { text: this.$t('ICE.ListICE.AGREED_LIMIT_COLUMN_NAME'), align: 'left', value: 'limit', sortable: false },
        { text: this.$t('ICE.ListICE.STATUS_COLUMN_NAME'), align: 'left', value: 'status', sortable: false }
      ],
      tableHeadersWithAction: [
        { text: '', align: 'left', value: 'first', sortable: false },
        { text: this.$t('ICE.ListICE.BUYER_COLUMN_NAME'), align: 'left', value: 'buyer', sortable: false },
        { text: this.$t('ICE.ListICE.REQUESTED_COLUMN_NAME'), align: 'left', value: 'requestedAmount', sortable: false },
        { text: this.$t('ICE.ListICE.AGREED_LIMIT_COLUMN_NAME'), align: 'left', value: 'limit', sortable: false },
        { text: this.$t('ICE.ListICE.STATUS_COLUMN_NAME'), align: 'left', value: 'status', sortable: false },
        { text: this.$t('ICE.ListICE.ACTION_COLUMN_NAME'), align: 'left', value: 'action', sortable: false }
      ]
    }
  },
  async mounted () {
    await this.loadAllEnvelopes(this.paginationData)
  },
  methods: {
    emptyPagination () {
      return {
        descending: true,
        page: 1,
        rowsPerPage: 5,
        sortBy: 'createdAt',
        totalItems: 0,
        rowsPerPageItems: [5]
      }
    },
    requestNewEnvelope () {
      this.currentEnvelope = undefined
      this.showEnvelopeDetailsDialog = true
    },
    async envelopeRequested (envelope) {
      this.currentFilter = 'all'
      this.currentEnvelope = envelope
      this.paginationData = this.emptyPagination()
    },
    async getEnvelopeBuyerObject (id) {
      let buyer = await transactorApi.fetchCompanyById(id)
      let envelopeBuyer = this.mapCompanyToEnvelopeBuyer(buyer)
      return envelopeBuyer
    },
    async getEnvelopeBuyerObjects (envelopes) {
      let buyerIds = envelopes.map(x => x.buyerId)
      let buyers = await transactorApi.fetchCompaniesByIds(buyerIds)
      let envelopeBuyers = buyers.map(x => [x.id, this.mapCompanyToEnvelopeBuyer(x)])
      return new Map(envelopeBuyers)
    },
    async loadAllEnvelopes (pagination = this.emptyPagination()) {
      try {
        this.isLoading = true
        this.envelopeList = []
        this.paginationData = pagination
        let response = await envelopeApi.getAllEnvelopes(this.paginationData.page - 1, this.paginationData.rowsPerPage, this.currentFilter)
        let envelopes = response.items
        this.paginationData.totalItems = response.totalCount
        if (envelopes && envelopes.length !== 0) {
          let envelopeBuyers = await this.getEnvelopeBuyerObjects(envelopes)
          envelopes.forEach(envelope => {
            envelope.buyer = envelopeBuyers.get(envelope.buyerId)
          })
          this.envelopeList = envelopes
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    mapCompanyToEnvelopeBuyer (company) {
      let mainIdentifier = company.companyIdentifiers.find(x => x.isPrincipal === true)
      let envelopeBuyer = {
        id: company.id,
        name: company.name,
        selectedCountry: company.address.countryCode,
        country: this.getCountry(company.address.countryCode).CountryName,
        mainIdentifierCode: mainIdentifier ? mainIdentifier.idTypeCode.toUpperCase() : '',
        mainIdentifierValue: mainIdentifier ? mainIdentifier.idValue : ''
      }
      envelopeBuyer = Object.assign(envelopeBuyer, company.address)
      return envelopeBuyer
    },
    showDetails (envelope) {
      this.currentEnvelope = envelope
      this.showEnvelopeDetailsDialog = true
    },
    async cancelEnvelope (envelopeId) {
      try {
        let envelope = await envelopeApi.cancelEnvelope(envelopeId)
        let envelopeIndex = this.envelopeList.findIndex(x => x.id === envelopeId)
        this.envelopeList[envelopeIndex].status = envelope.status
        this.paginationData = this.emptyPagination()
        this.$store.dispatch('global/setSnackbar', {
          show: true,
          color: 'success',
          text: `${this.labels.cancelEnvelopeSuccess}`,
          timeout: 6000
        })
      } catch (e) {
        this.$store.dispatch('global/setSnackbar', {
          show: true,
          color: 'error',
          text: `${this.labels.cancelEnvelopeFailed}`,
          timeout: 6000
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      getCountry: 'countries/getCountry'
    }),
    tableItems: function () {
      let filteredStatuses = []
      switch (this.currentFilter) {
        case 'all':
          filteredStatuses = []
          break
        case 'active':
          filteredStatuses = ['active']
          break
        case 'assessing':
          filteredStatuses = ['assessing']
          break
        case 'archived':
          filteredStatuses = ['cancelled', 'refused', 'cancelling']
          break
      }

      return this.envelopeList
        .filter(e => filteredStatuses.length === 0 || filteredStatuses.includes(e.status.toLowerCase()))
        .sort(function (a, b) {
          return Date.parse(a.requestedAt) > Date.parse(b.requestedAt) ? -1 : 1
        })
    },
    tableHeaders: function () {
      switch (this.currentFilter) {
        case 'all':
        case 'assessing':
        case 'active':
          return this.tableHeadersWithAction
        default:
          return this.defaultTableHeaders
      }
    },
    isActionEnabled: function () {
      return this.currentFilter !== 'archived'
    }
  }
}
</script>
